import {COUNTRIES_SHORT} from "../../config/countries.config";

export const COUNTRIES_DOMAINS = {
  default: COUNTRIES_SHORT.usa,
  mx: COUNTRIES_SHORT.mexico,
  fr: COUNTRIES_SHORT.france
}
